<script lang="typescript">
    import { onDestroy } from "svelte";
    import { push } from "svelte-spa-router";
    import { state, setState } from "./stores.js";
    import {
        MessageType,
        FocalType,
        ReadingAdd,
        EyeWearType,
        ContactLensType,
        ContactLensWearDaysPerWeek,
        ContactLensPrescriptionType,
    } from "./types";
    import PrescriptionButton from "./PrescriptionButton.svelte";
    import PrescriptionContinueButton from "./PrescriptionContinueButton.svelte";
    import ContactLensHelpButton from "./ContactLensHelpButton.svelte";

    if (!$state.splashScreenDismissed) {
        window.location.replace("/");
    }

    const selectContactLensType = (contactLensType: ContactLensType) => {
        setState({
            message: MessageType.SET_CONTACT_LENS_TYPE,
            contactLensType,
        });
    };

    const selectContactLensPrescriptionType = (
        contactLensPrescriptionType: ContactLensPrescriptionType
    ) => {
        setState({
            message: MessageType.SET_CONTACT_LENS_PRESCRIPTION_TYPE,
            contactLensPrescriptionType,
        });
    };

    const selectContactLensWearDaysPerWeek = (
        contactLensWearDaysPerWeek: ContactLensWearDaysPerWeek
    ) => {
        setState({
            message: MessageType.SET_CONTACT_LENS_WEAR_DAYS_PER_WEEK,
            contactLensWearDaysPerWeek,
        });
    };

    const transitionDelay = $state.focalType === FocalType.VARIFOCAL ? 400 : 0;

    let contactLensReady: boolean;
    $: contactLensReady =
        $state.eyeWearType === EyeWearType.CONTACT_LENS &&
        $state.contactLensType !== null &&
        $state.contactLensPrescriptionType !== null &&
        $state.contactLensWearDaysPerWeek !== null;

    onDestroy(() => window.scrollTo(0, 0));
</script>

<section class="justify-center h-screen py-8 overflow-y-hidden bg-primary">
    <div
        class="relative flex flex-col items-center justify-center h-full page-container bg-primary"
    >
        <ContactLensHelpButton />
        <h1 class="mb-4 text-5xl font-normal text-white">Choose your contact lens type</h1>
        <div class="flex items-center justify-center w-full pt-2 space-x-8">
            <!-- {#each getContactLensType() as label, i (label)} -->
            {#each Object.values(ContactLensType) as label, i}
                <PrescriptionButton
                    transitionParams={{ y: 350, duration: 600, delay: transitionDelay + 200 * i }}
                    onClick={() => selectContactLensType(label)}
                    isSelected={$state.contactLensType === label}
                >
                    {@html label}
                </PrescriptionButton>
            {/each}
        </div>
        <h2 class="mt-6 text-4xl font-normal text-white">Choose your prescription type</h2>
        {#if $state.contactLensPrescriptionType === ContactLensPrescriptionType.SPHERICAL}
            <p class="pt-8 text-xl font-normal text-white">
                If the prescription has a cyl of <b>0.75</b> or higher please choose the Toric option
            </p>
        {/if}
        <div class="flex items-center justify-center w-full pt-4 space-x-8">
            <!-- {#if $state.contactLensPrescriptionType === ContactLensPrescriptionType.SPHERICAL} -->
            {#each Object.values(ContactLensPrescriptionType) as label, i}
                <PrescriptionButton
                    transitionParams={{ y: 350, duration: 600, delay: transitionDelay + 200 * i }}
                    onClick={() => selectContactLensPrescriptionType(label)}
                    isSelected={$state.contactLensPrescriptionType === label}
                >
                    {@html label}
                </PrescriptionButton>
            {/each}
        </div>

        <h2 class="mt-8 text-4xl font-normal text-white">
            How many days per week do you wear contact lenses
        </h2>
        <div class="flex items-center justify-center w-full pt-8 space-x-8">
            {#each Object.values(ContactLensWearDaysPerWeek) as label, i}
                <PrescriptionButton
                    transitionParams={{ y: 350, duration: 600, delay: transitionDelay + 200 * i }}
                    onClick={() => selectContactLensWearDaysPerWeek(label)}
                    isSelected={$state.contactLensWearDaysPerWeek === label}
                >
                    {@html label}
                </PrescriptionButton>
            {/each}
        </div>

        <div class="flex items-center justify-center w-full pt-8 space-x-8">
            <PrescriptionContinueButton
                isActive={contactLensReady}
                next={"/contact-lenses/step2/"}
                transitionParams={{ y: 350, duration: 600, delay: 1200 }}
            />
        </div>
    </div>
</section>
